import styled, { css } from 'styled-components';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

// INTERFACES
import { ICardSelectStyle } from '../../interfaces/CardSelect.interface';

export const CardSelectHeaderStyled = styled.div<ICardSelectStyle>`
  position: absolute;
  top: 12px;
  right: 12px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  border: ${({ checked, disabled }) =>
    disabled && checked
      ? `3px solid ${theme.colors.states.disabled}`
      : checked
      ? `3px solid ${theme.colors.primary.bariBlue}`
      : 'none'};
  z-index: 9999;
  background-color: ${theme.colors.primary.white};
  display: flex;
  place-content: center center;
  align-items: center;

  ${({ checked }) =>
    checked &&
    css`
      &::after {
        content: '';
        margin: 0;
        background: ${theme.colors.primary.bariBlue};
        width: 14px;
        height: 14px;
        border-radius: 50%;
      }
    `}

  ${({ checked, disabled }) =>
    checked &&
    disabled &&
    css`
      &::after {
        content: '';
        margin: 0;
        background: ${theme.colors.states.disabled};
        width: 14px;
        height: 14px;
        border-radius: 50%;
      }
    `}
`;

export const CardSelectContent = styled.div`
  display: block;
`;

export const CardSelectStyled = styled.div<ICardSelectStyle>`
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${theme.colors.primary.white};
  border-radius: 12px;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  color: ${theme.colors.primary.black};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  width: 100%;
  max-width: 208px;
  min-height: 272px;
  padding: 40px 32px;

  & + div {
    margin-left: 40px;
    margin-top: 0px;
    @media (max-width: ${responsiveEndPoints.mobile}px) {
      margin-left: 0px;
      margin-top: 16px;
    }
  }


  ${({ disabled, checked }) =>
    !disabled &&
    css`
      &:hover {
        box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
        cursor: pointer;

        ${!checked &&
        css`
          > ${CardSelectHeaderStyled} {
            border: 2px solid ${theme.colors.primary.transparentBorder};
          }
        `}
      }
    `}

  ${({ checked }) =>
    checked &&
    css`
      background: ${theme.colors.states.selectedLightBlue};
      border: 2px solid ${theme.colors.primary.bariBlue};

      ::before {
        content: ' ';
        top: 0;
        left: 0;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        position: absolute;
        border: 2px solid ${theme.colors.states.selectedLightBlue};
        border-radius: 12px;
      }

      ::after {
        content: '';
        position: absolute;
        background: ${theme.colors.primary.bariBlue};
        z-index: -1;
      }
    `}


    ${({ checked, disabled }) =>
      checked &&
      disabled &&
      css`
        background: ${theme.colors.states.selectedLightBlue};
        border: 2px solid ${theme.colors.states.disabled};

        ::before {
          content: ' ';
          top: 0;
          left: 0;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          position: absolute;
          border: 2px solid ${theme.colors.states.selectedLightBlue};
          border-radius: 12px;
        }

        ::after {
          content: '';
          position: absolute;
          background: ${theme.colors.states.disabled};
          z-index: -1;
        }
      `}    

      ${({ disabled }) =>
        disabled &&
        css`
          cursor: not-allowed;
        `}          

    @media (max-width: ${responsiveEndPoints.mobile}px) {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      max-width: 100%;
      min-height: 120px;
      padding: 24px;
    }    
`;

export const CardSelectIconContainerStyled = styled.div`
  background: ${theme.colors.secondary.blue600};
  border-radius: 8px;
  width: max-content;
  padding: 10px;

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    height: 100%;
    margin-right: 16px;
  }
`;

export const CardSelectInputContainerStyled = styled.div`
  display: none;
`;

export const CardSelectTitleStyled = styled.h2`
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 8px;
  margin-top: 24px;
  font-weight: ${theme.weights.semibold};

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    margin-top: 0px;
  }
`;

export const CardSelectDescriptionStyled = styled.p`
  color: ${theme.colors.secondary.gray200};
  font-size: 13px;
  line-height: 24px;
  margin-top: 0;
`;

export const CardSelectInputStyled = styled.input`
  position: absolute;
`;
